import {Component, EventEmitter, Input, Output, OnChanges, OnInit} from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-history-component',
  templateUrl: './history-component.component.html',
  styleUrls: ['./history-component.component.scss']
})
export class HistoryComponentComponent implements OnChanges{
  constructor(private router: Router) { }
  @Input() historyStatement;
  @Input() transactionRecord = false;
  @Input() normalTab = false;
  @Input() cardTab = false;
  @Input() interBankTab = false;
  @Output() statmentNameString: EventEmitter<any> = new EventEmitter();
  @Output() emitScroll: EventEmitter<any> = new EventEmitter();
  @Input() pageLoading = false;
  @Input() resetAllCheckBox = false;
  @Input() etfFromMain = false;
  page = 0;
  pageSize = 20;
  @Input() doNothing = false;
  // TODO make all if and else to switch case !
  showReciept(transaction) {
    if (!this.doNothing) {
      if (this.etfFromMain) {
        transaction.returnPath = '/utilities/etfUtility/register';
        transaction.hideRate = true;
        localStorage.setItem('receipt', JSON.stringify(transaction));
        this.router.navigate(['receipt']);
        return;
      }
      transaction.returnPath = '/setting/transaction-records';
      transaction.hideRate = true;
      localStorage.setItem('receipt', JSON.stringify(transaction));
      this.router.navigate(['receipt']);
    }
  }
  selectTransaction(statement) {
    if (statement.active) {
      statement.active = false;
      this.statmentNameString.emit({ statement, removeMark: true });
    } else {
      statement.active = true;
      this.statmentNameString.emit({ statement, removeMark: false });
    }
  }
  ngOnChanges() {
    if (this.resetAllCheckBox && this.historyStatement.length > 0) {
      this.historyStatement.forEach(transaction => {
        transaction.active = false;
      });
    }
  }
  onScroll() {
    this.emitScroll.emit('');
  }
  getSrc(statement): string {
    if (statement.transactionStatus.toLowerCase() === 'failed') {
      return 'assets/img/close.svg';
    }
    if (statement.transactionStatus.toLowerCase() === 'success' && !(statement.resourceType === 'Deposit' && statement.fundTransferDetails?.destResourceType === 'IBAN')) {
      return 'assets/img/Tick-Stroke.svg';
    }
    if (statement.transactionStatus.toLowerCase() === 'success' && statement.resourceType === 'Deposit' && statement.fundTransferDetails?.destResourceType === 'IBAN') {
      return 'assets/img/Tick-Stroke.svg';
    }
    if (statement.transactionStatus.toLowerCase() === 'undone') {
      return 'assets/img/warning.svg';
    }
  }
}
